export default __webpack_public_path__ + "static/media/tindog clone.b2ff5776.png";